import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ImageIcon from '@mui/icons-material/Image';
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import UploadPromotionImageButtonProperties from './UploadPromotionImageButtonProperties';
import { useStyles } from './UploadPromotionImageButton.style';
import UploadPromotionImageStore from './UploadPromotionImageStore';
import UploadImageButton from '../UploadImageButton/UploadImageButton';


const UploadPromotionImageButton: React.FC<UploadPromotionImageButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  promotionId,
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();    
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new UploadPromotionImageStore(commonContext, promotionId);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const onFileSelect = (file: File) => {
        store.selectedImageFile = file;
    }

    const onImageSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            if (onSave) {
                setTimeout(() => {
                    onSave();
                }, 2000);
            }
        }
    }


    if (!userStore.hasAccess(Access.CREATE_AGENCY.valueOf())) {
        return <></>;
    }

    const text = "Seleccionar imagen de la promoción";
    const btnIcon = <ImageIcon/>;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={"Seleccionar Imagen"}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={"Seleccionar Imagen"}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal}
                       open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <UploadImageButton
                            onSelect={onFileSelect}
                            type={ButtonType.PRIMARY}/>
                        <Button
                            loading={store.loading} className={classes.input} onClick={onImageSave}
                            type={ButtonType.SECONDARY}
                            text={i18n.translate("SAVE")}/>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default UploadPromotionImageButton;
